<template>
    <div
        :class="{
            'grid-cell-alert grid-cell-warning': value != row.ExpectedStatus,
        }"
    >
        <DisplayTextWithRoute
            :value="value"
            translationprefix="trackingdevice"
            :routename="null"
        />
    </div>
</template>

<script setup lang="ts">
import type { TrackingDeviceStatus } from '@/objects/generated/enums/TrackingDeviceStatus';
import { DisplayTextWithRoute } from '@/components';
import type { TrackingDevice } from '@/objects/generated';

defineProps<{
    /**
     * The status of the tracking device
     */
    value: TrackingDeviceStatus;

    /**
     * The tracking device row
     */
    row: TrackingDevice;
}>();
</script>
